<script setup>
import { reactive, onMounted } from "vue";
import { useElements } from "./composables/elements";

const { renderElement } = useElements();

const props = defineProps({
  elements: { type: Array, required: true }, // список элементов
});


const popup = (el) => el?.style?.additional?.popup;

const openMap = reactive({});
const isOpen = (id) => !!openMap[id];
const open = (id) => (openMap[id] = true);
const close = (id) => (openMap[id] = false);

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  let scheduleIdFromUrl = null;

  if (urlParams.get("action") === "appointment-cancellation") {
    scheduleIdFromUrl = urlParams.get("schedule_id");
  } else {
    const hash = window.location.hash;
    if (hash.includes("action=appointment-cancellation")) {
      scheduleIdFromUrl = new URLSearchParams(hash.replace(/^#\/?/, "")).get("schedule_id");
    }
  }

  if (scheduleIdFromUrl) {
    const match = props.elements.find(
      (el) => popup(el)?.enabled && String(el.element?.scheduleId) === String(scheduleIdFromUrl)
    );
    if (match) open(match.id);
  }
});

const btnContainerClass = (el) => {
  const pos = popup(el)?.style?.position || "left";
  return {
    "text-start": pos === "left",
    "text-center": pos === "center",
    "text-end": pos === "right",
  };
};
</script>

<template>
  <div class="container-fluid vh-100 p-0 app-view">
    <div class="element-block" :class="element.style?.additional?.popup?.elementWidth || 'w-100'"
      v-for="element in props.elements" :key="element.id"
      v-show="element.style?.additional?.visible !== '0'">
      <component v-if="!popup(element)?.enabled" :is="renderElement(element.type, 'template')" :pageId="element.page_id"
        :data="element || {}" />
      <template v-else>
        <div class="col-12 popup-btn" :class="btnContainerClass(element)">
          <button type="button" class="btn" :class="popup(element).style?.widthClass || 'w-auto'"
            :style="popup(element).style?.element" @click="open(element.id)">
            {{ popup(element).value?.text || 'Open' }}
          </button>
        </div>

        <teleport to="body">
          <div v-if="isOpen(element.id)">
            <div class="popup-backdrop" @click="close(element.id)"></div>
            <div class="popup-modal-window" role="dialog" aria-modal="true" @click.stop>
              <div class="popup-modal-header d-flex justify-content-end p-2">
                <button type="button" class="btn btn-sm btn-secondary" @click="close(element.id)" aria-label="Close">
                  ✕
                </button>
              </div>
              <div class="popup-modal-body p-3">
                <component :is="renderElement(element.type, 'template')" :pageId="element.page_id"
                  :data="element || {}" />
              </div>
            </div>
          </div>
        </teleport>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.app-view {
  max-width: 720px !important;

  .element-block {
    display: inline-block;
  }

  .element-block.w-33 {
    width: 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    vertical-align: top;
  }

  .element-block.w-50 {
    width: 50%;
    flex: 0 0 50%;
    max-width: 50%;
    vertical-align: top;
  }

  .element-block.w-100 {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
    vertical-align: top;
  }
}

/* Фон модалки */
.popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 2999;
}

/* Окно модалки */
.popup-modal-window {
  position: fixed;
  top: 6vh;
  left: 50%;
  transform: translateX(-50%);
  max-width: min(92vw, 760px);
  width: 92vw;
  max-height: 88vh;
  overflow: auto;
  background: #fff;
  border-radius: 8px;
  z-index: 3000;
  box-shadow:
    0 4px 18px rgba(0, 0, 0, .2),
    0 6px 38px rgba(0, 0, 0, .19);
}

.popup-modal-header {
  border-bottom: 1px solid rgba(0, 0, 0, .05);
}

.popup-modal-body {
  background: #fff;
}
</style>
